/**
 * @desc 终审驳回批量编辑
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: Array<number>, options?: any) {
  return updateResponse(
    http(URL + `/wms/demandOrder/reject/batchReEdit`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
